import { Button } from '../ui/Button';
import { Icon } from '../ui/Icon';
import styles from './BootScreen.module.css';

interface BootScreenProps {
  error?: string | null;
}

/** Shown while the Discord handshake runs, and when it fails. */
export function BootScreen({ error }: BootScreenProps) {
  return (
    <div className={styles.screen}>
      <div className={styles.inner}>
        <span className={styles.mark}>
          <Icon name="logo" size={34} />
        </span>
        <h1 className={styles.title}>Spoyl</h1>

        {error ? (
          <>
            <p className={`${styles.message} ${styles.error}`}>Could not connect to Discord.</p>
            <p className={styles.details}>{error}</p>
            <Button variant="primary" icon="refresh" onClick={() => window.location.reload()}>
              Try again
            </Button>
          </>
        ) : (
          <>
            <span className={styles.spinner} />
            <p className={styles.message}>Connecting to Discord…</p>
          </>
        )}
      </div>
    </div>
  );
}
